<ng-template #balBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('address.save-address-first' | translate)
                : ('address.missing-data-for-save' | translate)
        "
        [loading]="isSaving()"
        icon="fa fa-save"
        [label]="'address.save-address-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    />
</ng-template>

<blockable-div
    #balBlock
    [class]="'w-full'"
    [blocked]="!model?.id"
    [blockUi]="balBlockUi"
>
    <!-- make sure addressId is in there first render -->
    @if (addressId()) {
        <app-bank-account-link-list-widget
            [autoFocusSearch]="false"
            [fillHeightList]="false"
            [addressId]="addressId()"
            [addInDialog]="true"
            [dialogEditMode]="true"
        />
    }
</blockable-div>
